<p>座席属性指定</p>
<button id="ssn-test-seat-attribute1" class="testButton" (click)="seatAttributeTest1()">座席属性指定へ</button>
